exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".img[data-v-c2e9aff2]{max-width:220px;margin-left:auto;margin-right:auto}", "", {"version":3,"sources":["/var/www/corretores.idealizacidades.com.br/source/src/components/login/Login.vue"],"names":[],"mappings":"AACA,sBACE,gBAAiB,AACjB,iBAAkB,AAClB,iBAAmB,CACpB","file":"Login.vue","sourcesContent":["\n.img[data-v-c2e9aff2] {\n  max-width: 220px;\n  margin-left: auto;\n  margin-right: auto;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":true,"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-c2e9aff2","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/login/Login.vue
// module id = 447
// module chunks = 8